import React, { useState, useEffect } from "react";
import instance from "../../api/api";
import InputCreate from "../../features/InputCreate";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelector, useDispatch } from "react-redux";
import { toogleVerifInfo } from "../../store/slice/PrintSlice";
// import Button from "../../features/Button";
// import { IoChevronBackCircleOutline } from "react-icons/io5";
import { Header, LoadingSpinner } from "../../shared/compoments";
import * as dayjs from "dayjs";
import { Help } from "../../utils";

dayjs().format();

const VerificationFacture = ({
  dateDebut,
  dateFin,
  Montant,
  NatureFacture,
  createfacture,
  isLoading,
}) => {
  const dispatch = useDispatch();
  return (
    <div className="w-50 bg-light p-3">
      <h5 className="text-center p-3">Vérification des informations</h5>
      <p>
        <strong className="text-secondary">Date début :{""}</strong>
        {new Date(dateDebut).toLocaleDateString("fr")}
      </p>
      <p>
        <strong className="text-secondary">Date fin :{""}</strong>
        {new Date(dateFin).toLocaleDateString("fr")}
      </p>
      <p>
        <strong className="text-secondary">Montant :{""}</strong>
        {Help.convertInMoney(Montant)} Fcfa
      </p>
      <p>
        <strong className="text-secondary">Nature de facture :{""}</strong>
        {NatureFacture}
      </p>
      <div className="d-flex justify-content-center gap-4">
        <button
          className="btn bg-success text-light"
          onClick={() => {
            createfacture();
          }}>
          {isLoading ? "Chargement..." : "Confirmer"}
        </button>
        <button
          className="btn bg-danger text-light"
          onClick={() => {
            dispatch(toogleVerifInfo());
          }}>
          Retour
        </button>
      </div>
    </div>
  );
};

function EditFactures() {
  const MySwal = withReactContent(Swal);
  const { id } = useParams();
  const dispatch = useDispatch();
  const verifInformation = useSelector((state) => state.print.verifInformation);
  const [detailFacture, setDetailFacture] = useState(null);
  const [data, setData] = useState({
    date_debut: "",
    date_fin: "",
    cost: "",
    type: "",
    contract_id: id,
    type: "",
  });

  // const [chooseContrat, setChooseContrat] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const createfacture = async () => {
    console.log("RESUME DATA", data);
    setIsLoading(true);
    try {
      const response = await instance.post("factures", data);
      console.log(
        "RESPONSE DATA",
        response.data.data.find((item) => Number(item.id) === Number(id))
      );
      if (response.data.status === false) {
        MySwal.fire({
          title: response.data.message,
          icon: "info",
          showConfirmButton: true,
        });
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setData({
          date_debut: "",
          date_fin: "",
          cost: "",
          type: "",
          contract_id: id,
        });

        dispatch(toogleVerifInfo());
        MySwal.fire({
          title: "Enregistrement reussi.",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.log(error);
      let msgError = [];
      for (const property in error.response.data.message) {
        msgError = [...msgError, error.response.data.message[property]];
      }
      MySwal.fire({
        title: msgError,
        icon: "info",
        showConfirmButton: true,
      });
      setIsLoading(false);
    }
  };
  useEffect(() => {
    const getListFactureDetail = async () => {
      const response = await instance.get("factures");
      console.log(
        "RESPONSE_DATA",
        response.data.data.find((item) => Number(item.id) === Number(id))
      );
      const element = response.data.data.find(
        (item) => Number(item.id) === Number(id)
      );
      setDetailFacture(element);
    };
    getListFactureDetail();
  }, []);
  if (!detailFacture) return <LoadingSpinner />;
  return (
    <div>
      {verifInformation && (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            background: "#00000069",
            display: "flex",
            justifyContent: "center",
            placeItems: "center",
            zIndex: "99",
          }}>
          <VerificationFacture
            isLoading={isLoading}
            createfacture={createfacture}
            dateDebut={data.date_debut}
            dateFin={data.date_fin}
            Montant={data.cost}
            NatureFacture={data.type}
          />
        </div>
      )}
      <Header libelle={`Editer une facture`} isReturn />
      <form className="px-3 my-3">
        <label htmlFor="duree">Nature de la fature</label>
        <select
          disabled
          for="duree"
          className="w-100 p-3"
          name=""
          id=""
          defaultValue={detailFacture.type}
          onChange={(e) => setData({ ...data, type: e.target.value })}>
          <option value="loyer">Loyer</option>
          <option value="caution">Caution</option>
          <option value="achat">Achat</option>
        </select>
        <section className="d-flex gap-3 align-items-center w-100 my-3">
          <div className="w-100">
            <InputCreate
              label="Date début"
              isDisabledInput
              typeInput="date"
              nameInput="debut"
              active={true}
              isMinActive={false}
              getValue={(e) => {
                setData({ ...data, date_debut: e.target.value });
              }}
              dataValue={detailFacture.date_debut}
            />
          </div>
          <div className="w-100 position-relative">
            <InputCreate
              label="Date fin"
              MydefaultValue
              typeInput="date"
              nameInput="fin"
              active={true}
              getValue={(e) => {
                setData({ ...data, date_fin: e.target.value });
              }}
              dataValue={detailFacture.date_fin}
            />
            {data.date_fin &&
              new Date(data.date_fin) < new Date(detailFacture.date_debut) && (
                <span
                  className="position-absolute text-danger"
                  style={{ fontSize: "1em" }}>
                  La date de fin doit etre supérieur à la date de début
                </span>
              )}
          </div>
        </section>

        {/* {data.date_debut && data.date_fin && (
          <div>
            {handleDiff(data.date_fin, data.date_debut) > 0 ? (
              <span className="text-danger m-2">
                {handleDiff(data.date_fin, data.date_debut)} {""} Mois (
                {Help.convertInMoney(
                  handleDiff(data.date_fin, data.date_debut) * prixPropriete
                )}{" "}
                Fcfa)
              </span>
            ) : (
              <span className="text-danger m-2">cela ne fait pas un mois</span>
            )}
          </div>
        )} */}
        <div>
          <InputCreate
            label="Montant (Fcfa)"
            typeInput="number"
            MydefaultValue
            nameInput="montant"
            active={true}
            getValue={(e) => {
              setData({ ...data, cost: e.target.value });
            }}
            dataValue={
              !detailFacture.total_restant
                ? detailFacture.cost
                : detailFacture.total_restant
            }
          />
          {/* {data.cost &&
            handleDiff(data.date_fin, data.date_debut) * prixPropriete !=
              data.cost && (
              <span className="text-danger">
                Le montant indiqué n'est pas correct..
              </span>
            )} */}
        </div>

        <div>
          <button
            className="btn bg-dark text-light mt-4"
            onClick={(e) => {
              e.preventDefault();
              if (
                data.contract_id &&
                data.date_debut &&
                data.type &&
                data.cost
              ) {
                dispatch(toogleVerifInfo());
              } else {
                window.alert("Veuillez renseigner tous les champs");
              }
            }}>
            Enregistrer
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditFactures;
